import TWEEN from '@tweenjs/tween.js'

const isNumber = function (exp) {
  let zero = exp - exp
  return zero === 0
}

function animate (time) {
  window.requestAnimationFrame(animate)
  TWEEN.update(time)
}
window.requestAnimationFrame(animate)

export default function (to, from, duration, cb, options = {delay: 0, easing: 'Bounce', easingEdge: 'Out'}, completeCb = function () {}) {
  if (typeof from !== typeof to) {
    // console.warn('animation: initial and target values are not the same type')
    return false
  }
  
  // Wrap the inital value into an object if it is not an object
  let wrapped = false
  if (typeof from !== 'object') {
    from = Number(from)
    to = Number(to)
    if (isNumber(from) && isNumber(to)) {
      wrapped = true
      from = {v: from}
      to = {v: to}
    } else {
      // console.warn('animation: initial or target is not a number')
      return false
    }
  }

  new TWEEN.Tween(from)
    .to(to, duration)
    .delay(options.delay)
    .easing(TWEEN.Easing[options.easing][options.easingEdge] || function (a) { return a})
    .onUpdate(() => {
      if (wrapped) {
        return cb(from.v)
      } else {
        return cb(from)
      }
    })
    .onComplete(() => {
      completeCb()
    })
    .start()
}
